import React from 'react'

const MobileFiltersGender = () => {
	return (
		<div>
			<div>
				<div className='mb-3'>
					<h5 className='text-normal text-black'>Gender</h5>
				</div>
				<div class='form-check mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Women <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check mb-2 '>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Girls <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check mb-2 '>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Infants <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check mb-2 '>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Men <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check mb-2 '>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Boys <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check mb-2 '>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Kids <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
		</div>
	)
}

export default MobileFiltersGender
